module.exports = __webpack_public_path__ + "static/bistrobo-archetecture-b2d64a25e1ee670dd97e285f35a4832c.svg";